import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import type { ChatTurnProps } from "../../types/chat";
import { ScreenStepTurn } from "../ScreenStepTurn";
import {
  getOfferRequestScreen,
  markOfferRequestScreenOpened,
} from "./offerRequestScreen";

export function OfferRequestTurn(props: ChatTurnProps) {
  const [screen] = useState(() => getOfferRequestScreen(props));

  useEffect(() => {
    if (screen) {
      markOfferRequestScreenOpened();
    }
  }, [screen]);

  if (!screen) {
    return <ScreenStepTurn {...props} />;
  }

  return <Navigate to={screen} replace />;
}
